const nicknames = [
  'kefir',
  'hleb',
  'baton',
  'tvorog',
  'syrnik',
  'pelmen',
  'varenik',
  'grechka',
  'kompot',
  'kvass',
  'shprota',
  'ukrop',
  'bulka',
  'ponchik',
  'vaflya',
  'bublik',
  'kasha',
  'manka',
  'plombir',
  'rassol',
  'ogurec',
  'morkov',
  'kartoshka',
  'kapusta',
  'kotleta',
  'pirozhok',
  'shaurma',
  'limonad',
  'barbaris',
  'iris',
  'zefir',
  'pastila',
  'smetana',
  'ryazhenka',
  'moloko',
  'salo',
  'ikra',
  'vobla',
  'krendel',
  'pechenka',
  'tapok',
  'shapka',
  'sviter',
  'kovrik',
  'divan',
  'stakan',
  'lozhka',
  'vilka',
  'tarelka',
  'lyustra',
  'shtorka',
  'lampa',
  'gvozdi',
  'plita',
  'oboi',
  'podval',
  'zavod',
  'lavka',
  'poezd',
  'tramvai',
  'bilet',
  'paket',
  'fonar',
  'dvor',
  'piter',
  'ural',
  'volga',
  'baikal',
  'bereza',
  'sosna',
  'malina',
  'vishnya',
  'raduga',
  'tuman',
  'sneg',
  'zima',
  'leto',
  'osen',
  'vesna',
  'rassvet',
  'iskra',
  'zvonok',
  'toska',
  'zabota',
  'pustota',
  'krinj',
  'vibe',
  'rofl',
  'skuf',
  'sigma',
  'slay',
  'chill',
  'cringe',
  'base',
  'sus',
  'npc',
  'delulu',
  'rizz',
  'aura',
  'drip',
  'mood',
  'mem',
  'glitch',
  'pixel',
  'lag',
  'ping',
  'cache',
  'bug',
  'patch',
  'deploy',
  'socket',
  'shader',
  'sprite',
] as const;

const createRandomNickname = () => (
  nicknames[Math.floor(Math.random() * nicknames.length)]!
);

let currentNickname: string = createRandomNickname();

export const getCurrentNickname = () => {
  return currentNickname;
};

export const setCurrentNickname = (nickname: string) => {
  const next = nickname.trim().toLowerCase();
  if (!next) return getCurrentNickname();
  currentNickname = next;
  return next;
};
